export default __webpack_public_path__ + "static/media/manage.1a5997b0.png";